import customAxios from "./axiosConfig";

const AccountantConnectionService = {
    getAccountantConnectionList: function(params) {
        let api_url = window.Urls["accountant_connection_list"]();
        return customAxios.get(api_url, {params: params});
    },
    getAccountantConnectionsV3: function(params) {
        var api_url = window.Urls["v3:accountantconnection_list"]();
        return customAxios.get(api_url, {params: params});
    },
    getAccountantTotals(params) {
        let api_url = window.Urls['accountant_connection_totals']()
        return customAxios.get(api_url, {params: params})
    },
    disconnect: function(pk) {
        var data = {
            'status': 'disconnected',
            'last_status_change': new Date()
        };

        var api_url = window.Urls['accountant_connection_detail'](pk);
        return customAxios.patch(api_url, data);
    },
    updateAccountantProfile: function(pk, data) {
        var api_url = window.Urls["accountant_profile_detail"](pk);
        return customAxios.patch(api_url, data);
    },
    sendInvite: function(data) {
        var api_url = window.Urls["freelancerinvite_list"]();
        return customAxios.post(api_url, data);
    },
    listNextPage: function(next_url) {
        return customAxios.get(next_url);
    },
    deleteInvite: function(pk) {
        var api_url = window.Urls['freelancerinvite_detail'](pk);
        return customAxios.delete(api_url);
    },
    getCustomerInformation: function(pk) {
        var api_url = window.Urls["accountant_profile_retrieve_customer_information"](pk);
        return customAxios.get(api_url);
    },
    getPendingInvites: function() {
        var api_url = window.Urls["freelancerinvite_list"]();
        return customAxios.get(api_url);
    },
    resendInvite: function(pk) {
        var api_url = window.Urls['freelancerinvite_resend'](pk);
        return customAxios.post(api_url);
    },
    searchCompanies: function(params) {
        var api_url = window.Urls['company-profile-search-company-profiles']();
        return customAxios.get(api_url, {params: params});
    },
    createGekkoConnection: function(gekko_company_profile, customer_company_profile) {
        var data = {
            customer_company: customer_company_profile
        }
        var api_url = window.Urls['accountant-connection-create-gekko-connection'](gekko_company_profile);
        return customAxios.post(api_url, data);
    }
}

export default AccountantConnectionService;